import cx from 'classnames';

import { backgroundClassMap, borderClassMap } from './BackgroundLayout.consts';
import type { BackgroundLayoutProps } from './BackgroundLayout.types';

import styles from './BackgroundLayout.module.scss';

export const BackgroundLayout: React.FC<BackgroundLayoutProps> = ({
	backgroundColour,
	border,
	children,
	className = '',
	id = '',
	withShadow,
}) => {
	return (
		<div
			className={cx(styles.wrapper, backgroundClassMap[backgroundColour], borderClassMap[border], {
				[styles.shadow]: withShadow,
				[className]: className,
			})}
			data-testid={`background-layout${id ? `-${id}` : ''}`}
			id={id}
		>
			{children}
		</div>
	);
};
